import { ENVIRONMENT } from '@evc/platform';

import type { OrganizationEnv } from '@app/types/config.type';

export { ENVIRONMENT } from '@evc/platform';

export const environment: OrganizationEnv = {
  APP_NAME: 'organization',
  ENV: ENVIRONMENT.production,
  USE_CONNECT_PLATFORM: true,
  AUTH_FORCE_ORGANIZATION: false,
};
